import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('q-system');

export class Statements extends Api {
  constructor(http, config = {}) {
    super(http, url, 'statements', config);
  }
}